// packages/main/app/web/components-v2/UnifiedImageDialog/AIGenerateTab.tsx
import * as Api from '@ViewModels';
import * as React from 'react';
import { AIImageChat } from './AIImageChat';
import { PostContentType } from './types';
import { useAddAIImageToLibrary } from './useAddAIImageToLibrary';

interface AIGenerateTabProps {
	onImageSelected: (image: Api.IFileAttachment) => void;
	impersonationContext?: Api.IImpersonationContext;
	postContent?: string;
	postContentType?: PostContentType;
	addToLibrary?: boolean;
}

export function AIGenerateTab({
	onImageSelected,
	impersonationContext,
	postContent,
	postContentType,
	addToLibrary,
}: AIGenerateTabProps) {
	const selectImage = useAddAIImageToLibrary({ addToLibrary, impersonationContext, onImageSelected });

	// Adapt AIImageChat's array callback to AIGenerateTab's single image callback
	const handleImageSelected = React.useCallback(
		(fileAttachments: Api.IFileAttachment[]) => {
			if (fileAttachments.length > 0) {
				selectImage(fileAttachments[0]);
			}
		},
		[selectImage]
	);

	return (
		<AIImageChat
			onImageSelected={handleImageSelected}
			impersonationContext={impersonationContext}
			postContent={postContent}
			postContentType={postContentType}
		/>
	);
}
